import moment from "moment";
import { endpoint } from "../../views/pages/manage/common/constant"
import { templateUrl } from "../../views/pages/manage/common/constant/endpoints/documentService";
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, updateRequest } from "../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { downLoadFile } from "../../views/pages/manage/masters/studentFinancials/paymentCollection/bulkCollection/utils";
import { bulkTransferStatusDropdown } from "./constants";


export const fetchBulkPaymentTransferProcessTags = async () => {
    const allActiveProcessTags = await dropdownMapping(
        endpoint.process_Tag.getAllActive,
        "tagTypeDispValue",
        "tagTypeDesc",
        "tagTypeKey",
        "id"
    );

    return allActiveProcessTags;

    // return fetchAllPromisedData(endpoint.process_Tag.getAllActive);
}

export const downloadTemplate = async serviceName => {
    const resp = await fetchAllPromisedData(`${templateUrl}?documentTypeDisplayValue=${serviceName}&serviceType=${serviceName}`);
    downLoadFile(resp?.["Template Url"]);

}

export const saveFileData = (file, paymentTransferType,bulkPaymentTransferProcessTag) => {
debugger
    const req = {
        processId: file?.paymentTransferFile?.processId,
        status: "ACTIVE",
        extId: file?.paymentTransferFile?.processId,
        documentType: file?.paymentTransferFile?.docType,
        signedUrl: "",
        isProcess: true,
        serviceName: bulkPaymentTransferProcessTag?.tagTypeKey,
        processTagTypeId: bulkPaymentTransferProcessTag?.id,
        fileName: file?.paymentTransferFile?.fileName,
        supportingDocKey: file?.supportingFile?.s3Key,
        type: paymentTransferType?.label
    }

    return fetchAllPostPromisedData(endpoint.fetchS3Url.commonUploadDms, req);
}

export const fetchBulkPaymentTransferRequests = ({ filters, pageSize, offset }) => {
    const req = updateRequest({ ...filters, fromProcessingDate: filters?.fromProcessingDate ? moment(filters?.fromProcessingDate)?.startOf('day')?.format() : null, toProcessingDate: filters?.toProcessingDate ? moment(filters?.toProcessingDate)?.endOf('day')?.format() : null });
    return fetchAllPostPromisedData(`${endpoint?.paymentTransfer?.search}?offset=${offset}&pageSize=${pageSize}`, req);
}

export const getSubmissionStatusExcelDetails = processId => {
    return fetchAllPromisedData(`${endpoint?.paymentTransfer?.getBulkUploadDetailsByPid}?pid=${processId}`);
}


export const getFilterFormFields = (paymentMode=[], reqForm={}) => {

    return [
        {
            label: 'Process Id',
            type: 'text',
            formKey: 'processInstanceId',
            onChange: () => { },
            placeholder: "Enter",
            disabled: false,
        },
        {
            label: 'Payment Method',
            type: 'select',
            items: paymentMode,
            formKey: 'paymentMode',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Payment Method",
            disabled: false,
            isShowCount: true
        },

        {
            label: 'Uploaded By',
            type: 'text',
            formKey: 'uploadedBy',
            onChange: () => { },
            placeholder: "Enter",
            disbabled: false,
        },

        {
            label: 'Process Date From',
            type: 'date',
            formKey: 'fromProcessingDate',
            onChange: () => { },
            placeholder: "Select date",
            disabled: false,
            minDate: '',
            maxDate: reqForm?.toProcessingDate||moment(new Date()),
        },
        {
            label: 'Process Date To',
            type: 'date',
            formKey: 'toProcessingDate',
            onChange: () => { },
            placeholder: "Select date",
            disabled: false,
            minDate: reqForm?.fromProcessingDate,
            maxDate: moment(new Date()),
        },
    ]

}

